import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

//import { AuthGuard } from './auth/auth.guard';

import  { LoginComponent } from './components/login/login.component'
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import {AccesoDenegadoComponent} from './components/acceso-denegado/acceso-denegado.component'
import { MiPerfilComponent } from './components/mi-perfil/mi-perfil.component';
import {EntrenadoresModule} from "./modules/trainer-dashboard/trainer-dashboard.module";
import { ClientesComponent } from './modules/trainer-dashboard/clientes/clientes.component';
import { authGuard } from './auth/auth.guard';

const routes: Routes = [
    {
        path: 'login',
        component: LoginComponent,
    },
    {
        path: 'forgot-password',
        component: ForgotPasswordComponent
    },

    // {
    //     path        : 'mi-perfil',
    //     component   : MiPerfilComponent,
    //     canActivate : [AuthGuard],
    //     data        : {
    //         roles: ['1', '2', '3', '4', '99']
    //     }
    // },
    {
        path: 'trainer',
        canActivate: [authGuard],
        loadChildren: () =>
            import('./modules/trainer-dashboard/trainer-dashboard.module').then((m) => m.EntrenadoresModule),
    },
    {
        path: 'cliente',
        canActivate: [authGuard],
        loadChildren: () =>
            import('./modules/client-dashboard/client-dashboard.module').then((m) => m.ClientDashboardModule),
    },
    //{ path: 'trainer', loadChildren: () => import('./modules/trainer-dashboard/trainer-dashboard.module').then(m => m.EntrenadoresModule) },
    {
        path: '**',
        redirectTo: 'login'
    }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
